import { StageTrigger } from '@templates/index';
import { useUiStore } from '@store/index';

export function SynthTrigger() {
  const setOpen = useUiStore((s) => s.setSynthOpen);
  return <StageTrigger label="SYNTH" offsetLeft={96} onClick={() => setOpen(true)} />;
}
